<template>
    <div class="modal fade show" id="sleepData" tabindex="-1" role="dialog" aria-labelledby="sleepData" aria-hidden="true" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Glucose Level</h4>
                    <button type="button" class="close" @click.prevent="$parent.toggleForm();selectFutureTime = false">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <loader v-if="pageLoader"></loader>
                    <div class="form-group field-wrapper">
                        <input type="number" class="float-field form-control" placeholder="Glucose Level"  name="Glucose Level" v-model="glucose_level" v-validate="'required|decimal:3'" />
                        <p class="error" v-if="submitted" v-for="error in errors.collect('Glucose Level')">{{ error }}</p>
                    </div>
                    <div class="Sleep_input">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="form-group field-wrapper" v-if="from == ''">
                                <input class="float-field form-control" type="date" name="date" v-model="date" v-validate="'required'" :max="disableFuture">
                                <p class="error" v-if="submitted && errors.has('time')">Date field is required </p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input class="float-field form-control" type="time" :max="disableFutureTime" name="time" v-model="time" v-validate="'required'">
                                <p class="error" v-if="submitted && errors.has('time')">Time field is required </p>
                                <p class="error" v-if="submitted && selectFutureTime">Please Select time before current time</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default red" data-dismiss="modal" @click.prevent="$parent.toggleForm();selectFutureTime = false">Close</button>
                    <button type="button" class="btn btn-default btn-blue" @click.prevent="SaveGlucosedata()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    export default {
        name: "Glucose-Level",
        data() {
            return {
                pageLoader : false,
                submitted : false,
                glucose_level:'',
                date:'',
                time: '',
                disableFutureTime: moment().format("HH:mm"),
                disableFuture: moment().format("YYYY-MM-DD"),
                selectFutureTime : false
            };
        },
        props:['from'],
        methods:{
            changeTime(){
                if(this.from == ''){
                    const d = new Date(this.date);
                    if(this.time){
                        let hours = this.time.split(':')[0]
                        let minutes = this.time.split(':')[1]  
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }
                    return d
                }else{
                    const d1 = new Date();
                    if(this.time){
                        let hours = this.time.split(':')[0]
                        let minutes = this.time.split(':')[1]
                        if(this.$parent.filter == 'today'){  
                            d1.setHours(parseInt(hours))
                            d1.setMinutes(parseInt(minutes))
                        }else{
                            d1.setDate(d1.getDate()-1);
                            d1.setHours(parseInt(hours))
                            d1.setMinutes(parseInt(minutes))
                        }
                    }
                    return d1
                }
            },
            SaveGlucosedata(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        const d = new Date();
                        let hrs = this.time.split(':')[0]
                        let mns = this.time.split(':')[1]
                        d.setHours(parseInt(hrs))
                        d.setMinutes(parseInt(mns))
                        if((this.from == 'daily-task' && this.$parent.filter == 'today' || (this.date && moment(this.date).isSame(moment(),'day'))) && moment(d).diff(moment(),'minutes') > 0){
                            this.selectFutureTime = true
                        }else{
                            this.selectFutureTime = false
                            let input_json = {
                                'globalParams' : {
                                    "datetime" : moment(_that.changeTime()).format('YYYY-MM-DD HH:mm'),
                                    "value" : _that.glucose_level,
                                    "gulcose_id" : '',
                                },'localParams' : {'parameter' : _that}
                            }
                            if(this.from){
                                input_json.localParams.from = this.from
                            }
                            this._runAddGlucoseData(input_json)
                        }
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.high = ''
                this.low = ''
                this.time = ''
                this.selectFutureTime = false
            }   
        },
        created(){
           this.pageName('Input Glucose Level')
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/website/user/forms/glucose-level.vue